export const WEBSITE_URL = "https://thegeekyindian.com";
export const MEDIUM_SCREEN_WIDTH = 992;
